var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForm1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.3541,
    height: 33.3541,
    rx: 16.6771,
    fill: "#D7F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8622 11.1916C13.3823 10.3415 13.1423 9.91643 13.2832 9.53C13.424 9.14357 13.8774 8.98295 14.7843 8.66168L15.5565 8.38814C16.1113 8.1916 16.3887 8.09332 16.6767 8.09332C16.9647 8.09332 17.2421 8.1916 17.7969 8.38814L18.5691 8.66168C19.4759 8.98295 19.9293 9.14357 20.0702 9.53C20.211 9.91643 19.971 10.3415 19.4911 11.1916L19.048 11.9763C18.8208 12.3788 18.7072 12.5801 18.5084 12.7379C18.3095 12.8957 18.1252 12.9484 17.7566 13.0538C17.4035 13.1548 17.0009 13.2436 16.6767 13.2436C16.3525 13.2436 15.9499 13.1548 15.5967 13.0538C15.2282 12.9484 15.0439 12.8957 14.845 12.7379C14.6461 12.5801 14.5325 12.3788 14.3053 11.9763L13.8622 11.1916Z",
    stroke: "#007E8C",
    strokeWidth: 1.03005
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.028 13.2436L13.6042 19.3757C13.2955 20.7056 13.1411 21.3705 13.3175 21.9957C13.3209 22.0079 13.3244 22.0201 13.3281 22.0322C13.5138 22.6547 13.9991 23.1297 14.9695 24.0796C15.7701 24.8633 16.1705 25.2551 16.6627 25.2608C16.672 25.2609 16.6813 25.2609 16.6907 25.2608C17.1829 25.2551 17.5832 24.8633 18.3838 24.0796C19.3543 23.1297 19.8395 22.6547 20.0253 22.0322C20.0289 22.0201 20.0324 22.0079 20.0359 21.9957C20.2122 21.3705 20.0579 20.7056 19.7492 19.3757L18.3254 13.2436",
    stroke: "#007E8C",
    strokeWidth: 1.03005
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm1);
export default __webpack_public_path__ + "static/media/form-1.8abaaf1a106799dc21b6ce858cbf26f3.svg";
export { ForwardRef as ReactComponent };